// extracted by mini-css-extract-plugin
export default {"Table":"cancel_Table__HyTnf","ReloadBtn":"cancel_ReloadBtn__HJR7T","TableMobile":"cancel_TableMobile__dfSHw"};